export const DATADOG_ERRORS = {
  initialisation: 'DatadogRumInitialisationError',
} as const;
